import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { Drawer, AutoComplete, Input, DatePicker, TimePicker, message, Tooltip, Spin } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment'
import { connect } from 'react-redux'
import {
    setSubject, setClass, setTeacher, setStartTime, setEndTime, setSartDate, setEndDate, setMode, setWeekDays, fetchSubList,
    fetchClassList, fetchTeacherList, postCreateSchedule, fetchSchedule, fetchTimetableData, fetchScheduleFilter, setCurrentDate
} from '../../actions/schedule'
import { EventRegister } from 'react-native-event-listeners'
import SavingModal from 'components/SavingModal'
import { Notification } from 'services'
import PageDataLoader from 'components/pageDataLoader'

import calenderIcon from "../../Assets/schedule/calendar.svg"
import deleteIcon from "../../Assets/schedule/delete.svg"
import clockIcon from "../../Assets/schedule/clock.svg"
import downArrowIcon from "../../Assets/schedule/downArrow.svg"
import upArrowIcon from "../../Assets/schedule/upArrow.svg"

// The gap between each field (Subject/Batch/Instructor/Mode/Date/Time/Repeat-on) is a flat
// 24px regardless of zoom. At higher zoom the form's total content height can exceed the
// scroll container's flex-allocated box, and since that container briefly drops its clip
// while a date/time popup is open (so the popup isn't cut off), the trailing Repeat-on
// row can spill out along with it and visually collide with the footer below. Shrinking
// the gaps at higher zoom (keyed off window.outerHeight - the physical window size, which
// zoom doesn't change - same approach as ScheduleDetailsTab.js's getResponsiveDetailsVars)
// means the content is more likely to actually fit within that box in the first place, so
// there's nothing left to spill in typical cases.
const getResponsiveFieldGap = () => {
    const oh = typeof window !== 'undefined' && window.outerHeight ? window.outerHeight : 1080
    if (oh <= 700) return 12
    if (oh <= 850) return 16
    if (oh <= 950) return 20
    return 24
}

const CreateScheduleDrawer = ({
    open,
    onClose,
    // Redux state
    subList, fetchSubList, fetchClassList, classList, setSubject, setClass, subId, teacherList, fetchTeacherList,
    setTeacher, setStartTime, setSartDate, setEndDate, setEndTime, setMode, weekdays, setWeekDays, classId, teacherId,
    startTime, endTime, startDate, endDate, postCreateSchedule, mode, tabType, stdTimetable, fetchSchedule,
    fetchTimetableData, currentDate, fetchScheduleFilter, subsAlertData, setIsSubModalVisible, teacherSearch, classFilter, subFilter,
    setCurrentDate, togglePageLoader, pageLoader
}) => {
    const [colorDays, setColorDays] = useState([false, false, false, false, false, false, false])
    const [optionSub, setOptionsSub] = useState([])
    const [optionClass, setOptionsClass] = useState([])
    const [optionTeacher, setOptionsTeacher] = useState([])
    const [cachedSubList, setCachedSubList] = useState(null)
    const [cachedClassList, setCachedClassList] = useState(null)
    const [cachedTeacherList, setCachedTeacherList] = useState(null)
    const [subName, setSubName] = useState('')
    const [className, setClassName] = useState('')
    const [teacherName, setTeacherName] = useState('')
    const [classNameArr, setClassNameArr] = useState([])
    const [showBatchInput, setShowBatchInput] = useState(false)
    const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false)
    const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false)
    const [batchDropdownOpen, setBatchDropdownOpen] = useState(false)
    const [isSearchingSub, setIsSearchingSub] = useState(false)
    const [isSearchingTeacher, setIsSearchingTeacher] = useState(false)
    const [subFocused, setSubFocused] = useState(false)
    const [batchFocused, setBatchFocused] = useState(false)
    const [teacherFocused, setTeacherFocused] = useState(false)
    const [startDateFocused, setStartDateFocused] = useState(false)
    const [endDateFocused, setEndDateFocused] = useState(false)
    const [startTimeFocused, setStartTimeFocused] = useState(false)
    const [endTimeFocused, setEndTimeFocused] = useState(false)
    const [subjectLoader, setSubjectLoader] = useState(false)
    const [stdLoader, setStdLoader] = useState(false)
    const [teacherLoader, setTeacherLoader] = useState(false)
    const [suppressSubOptionsUpdate, setSuppressSubOptionsUpdate] = useState(false)
    const subRef = useRef(null)
    const instructorRef = useRef(null)
    const startDateRef = useRef(null)
    const endDateRef = useRef(null)
    const startTimeRef = useRef(null)
    const endTimeRef = useRef(null)
    // Plain DOM refs on each date/time field's own wrapper, used only to scroll that field
    // into view when its picker opens - antd's DatePicker/TimePicker ref (above) exposes
    // focus/blur, not the DOM node, so it can't be used for this.
    const startDateWrapRef = useRef(null)
    const endDateWrapRef = useRef(null)
    const startTimeWrapRef = useRef(null)
    const endTimeWrapRef = useRef(null)
    const isManualClearRef = useRef(false)

    // Scrolls a date/time field to the top of the scroll container when its picker opens,
    // maximizing the room left below for the popup (which opens downward, in normal flow,
    // inside the always-clipping scroll container - no more toggling overflow to 'visible'
    // to let it render over the footer instead). If the popup still doesn't fully fit, the
    // container's own scrollbar - not an overlap onto the footer - is what shows the rest.
    const scrollFieldIntoView = (wrapRef) => {
        setTimeout(() => {
            wrapRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 0)
    }

    const format = 'hh:mm A'
    const formatDate = "DD/MM/YYYY"

    const pickerStyle = {
        width: '100%',
        height: 28,
        border: 'none',
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
        outline: 'none',
    }

    const [showModal, setShowModal] = useState(false)
    const [modalConfig, setModalConfig] = useState({ type: '', title: '', message: '', confirmText: 'YES' })
    const [hoverStartDate, setHoverStartDate] = useState(false)
    const [hoverEndDate, setHoverEndDate] = useState(false)
    const [hoverStartTime, setHoverStartTime] = useState(false)
    const [hoverEndTime, setHoverEndTime] = useState(false)
    const isFormValid = Boolean(subId && startTime && endTime && startDate && endDate && mode && Array.isArray(classId) && classId.length !== 0 && teacherId && Array.isArray(weekdays) && weekdays.length !== 0)

    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth <= 480 ? '100%' : (window.innerWidth <= 1024 ? '80%' : 592));

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 480) {
                setDrawerWidth('100%');
            } else if (window.innerWidth <= 1024) {
                setDrawerWidth('80%');
            } else {
                setDrawerWidth(592);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [fieldGap, setFieldGap] = useState(getResponsiveFieldGap);
    useEffect(() => {
        const onResize = () => setFieldGap(getResponsiveFieldGap());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        if (open) {
            handleReset()
            fetchSubList()
            fetchTeacherList('')
        }
    }, [open])

    useEffect(() => {
        if (suppressSubOptionsUpdate) return
        const currentSubName = subList?.find(s => s.id === subId)?.name || ''
        const isSearchActive = subName !== currentSubName || isSearchingSub

        const opts = subList ? subList.filter(item =>
            !isSearchActive || item.name.toLowerCase().includes(subName.toLowerCase())
        ).map((item, index) => ({
            key: index,
            value: item.name,
            label: item.name,
            id: item.id,
            className: item.id === subId ? 'custom-selected-option' : ''
        })) : []
        // Only show the 'No subject found' placeholder when the user has typed a query
        if ((!opts || opts.length === 0) && isSearchActive && subName) {
            setOptionsSub([{ key: 'no-data', value: 'no-data', label: 'No subject found', disabled: true }])
        } else {
            setOptionsSub(opts)
        }
        if (!subName) setCachedSubList(subList)
    }, [subList, subName, suppressSubOptionsUpdate, subjectDropdownOpen, subId, isSearchingSub])

    useEffect(() => {
        const selectedIds = Array.isArray(classId) ? classId : []
        const available = classList ? classList.filter(c => !selectedIds.includes(c.id)) : []
        const opts = available.map((item, index) => ({ key: index, value: `${item.std} : ${item.section}`, label: `${item.std} : ${item.section}`, id: item.id }))
        if ((!opts || opts.length === 0)) {
            setOptionsClass([{ key: 'no-data', value: 'no-data', label: 'No batch found', disabled: true }])
        } else {
            setOptionsClass(opts)
        }
        if (!className) setCachedClassList(classList)
    }, [classList, className, classId])

    useEffect(() => {
        const currentTeacherName = teacherList?.find(t => t.id === teacherId)?.name || ''
        const isSearchActive = teacherName !== currentTeacherName || isSearchingTeacher

        const opts = teacherList ? teacherList.filter(item =>
            !isSearchActive || item.name.toLowerCase().includes(teacherName.toLowerCase())
        ).map((item, index) => ({
            key: index,
            value: item.name,
            label: item.name,
            id: item.id,
            className: item.id === teacherId ? 'custom-selected-option' : ''
        })) : []
        if ((!opts || opts.length === 0) && isSearchActive && teacherName) {
            setOptionsTeacher([{ key: 'no-data', value: 'no-data', label: 'No instructor found', disabled: true }])
        } else {
            setOptionsTeacher(opts)
        }
        if (!teacherName) setCachedTeacherList(teacherList)
    }, [teacherList, teacherName, teacherId, isSearchingTeacher])

    const handleSearchSub = (value) => {
        if (!value) {
            setSubName('')
            setIsSearchingSub(false)
            setSubject(null)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
        }
        else {
            setSubName(value);
            setSubjectLoader(true);
            setIsSearchingSub(true)
            setSubject(null)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
        }
        fetchSubList(value, () => setSubjectLoader(false))
    }

    const onSelectSub = (value, option) => {
        setIsSearchingSub(false)
        if (!value || value === 'no-data') return
        const id = option?.id || (subList && subList.find(s => s.name === value)?.id)
        if (id) {
            setSubject(id)
            setSubName(value)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
            setBatchFocused(false)
            fetchClassList('', id)
        } else {
            setSubject(null)
            setSubName('')
        }
    }

    const handleSearchClass = (value) => {
        if (value) {
            setClassName(value)
            setStdLoader(true)
            fetchClassList(value, subId, () => setStdLoader(false))
        } else {
            setClassName('')
            fetchClassList('', subId, () => setStdLoader(false))
        }
    }

    const onSelectClass = (value, option) => {
        if (!value || value === 'no-data') return
        const id = option?.id || (classList && classList.find(c => `${c.std} : ${c.section}` === value)?.id)
        if (id) {
            const newClassIds = Array.isArray(classId) ? [...classId] : []
            const newClassNameArr = Array.isArray(classNameArr) ? [...classNameArr] : []
            if (!newClassIds.includes(id)) {
                newClassIds.push(id)
                newClassNameArr.push({ id: id, name: value })
                setClass(newClassIds)
                setClassNameArr(newClassNameArr)
            }
            setClassName('')

            // Check if there are more batches available
            const remainingBatches = (classList || []).filter(c => !newClassIds.includes(c.id))
            if (remainingBatches.length > 0) {
                setShowBatchInput(false)
                setBatchDropdownOpen(false)
            } else {
                setShowBatchInput(false)
                setBatchDropdownOpen(false)
            }

            fetchTeacherList('')
        } else {
            setClass([])
            setClassName('')
            setClassNameArr([])
            setTeacher(null)
            setTeacherName('')
        }
    }

    const handleSearchTeacher = (value) => {
        if (!value) {
            setTeacherName('')
            setIsSearchingTeacher(false)
            setTeacher(null)
        }
        else {
            setTeacherName(value);
            setTeacherLoader(true);
            setIsSearchingTeacher(true)
            setTeacher(null)
        }
        fetchTeacherList(value, () => setTeacherLoader(false))
    }

    const onSelectTeacher = (value, option) => {
        setIsSearchingTeacher(false)
        if (!value || value === 'no-data') return
        const id = option?.id || (teacherList && teacherList.find(t => t.name === value)?.id)
        if (id) {
            setTeacher(id)
            setTeacherName(value)
        } else {
            setTeacher(null)
            setTeacherName('')
        }
    }

    const handleDaysButtonColor = (value, active) => {
        let newWeekdays = Array.isArray(weekdays) ? [...weekdays] : []
        const newColor = [...colorDays]
        const toggleDay = (index, dayName) => {
            newColor[index] = !active
            if (newColor[index]) {
                if (!newWeekdays.includes(dayName)) newWeekdays.push(dayName)
            } else {
                newWeekdays = newWeekdays.filter((w) => w !== dayName)
            }
            setColorDays(newColor)
        }
        if (value == "Su") toggleDay(0, 'sunday')
        else if (value == "M") toggleDay(1, 'monday')
        else if (value == "T") toggleDay(2, 'tuesday')
        else if (value == "W") toggleDay(3, 'wednesday')
        else if (value == "Th") toggleDay(4, 'thursday')
        else if (value == "F") toggleDay(5, 'friday')
        else if (value == "S") toggleDay(6, 'saturday')
        setWeekDays(newWeekdays)
    }

    const onChangeStartDate = (date, dateString) => {
        if (dateString) {
            setSartDate(moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD'))
        } else {
            setSartDate('')
            setStartDateFocused(false)
            startDateRef.current?.blur()
        }
        setEndDate('')
    }

    const onChangeLastDate = (date, dateString) => {
        if (dateString) {
            setEndDate(moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD'))
        } else {
            setEndDate('')
            setEndDateFocused(false)
            endDateRef.current?.blur()
        }
    }

    const onChangeStartTime = (time, timestring) => {
        setEndTime('')
        if (time) {
            const timestring24 = moment(time, format).format('HH:mm')
            if (mode === 'Zoom 40') {
                if (timestring24 > "23:19") {
                    let temp = 59 - timestring24.substring(3, 5)
                    setEndTime(moment(timestring24, "HH:mm").add(temp, 'minutes').format('HH:mm'))
                } else {
                    setEndTime(moment(timestring24, "HH:mm").add(40, 'minutes').format('HH:mm'))
                }
            }
            setStartTime(timestring24)
        } else {
            setStartTime('')
            setStartTimeFocused(false)
            startTimeRef.current?.blur()
        }
    }

    const onChangeEndTime = (time, timestring) => {
        if (time) {
            setEndTime(moment(time, format).format('HH:mm'))
        } else {
            setEndTime('')
            setEndTimeFocused(false)
            endTimeRef.current?.blur()
        }
    }

    const onClose_Class = (value) => {
        const newClassNameArr = classNameArr.filter((item) => item.id != value)
        const newClassIds = (Array.isArray(classId) ? classId : []).filter((item) => item != value)
        setClass(newClassIds)
        setClassNameArr(newClassNameArr)
        setClassName('')

        if (newClassNameArr.length === 0) {
            setShowBatchInput(false)
            setBatchFocused(false)
        }

        // Check if we should show "ADD BATCH" button
        const remainingBatches = (classList || []).filter(c => !newClassIds.includes(c.id))
    }

    const disabledStartDate = (current) => {
        if (!current) return false
        return current.isBefore(moment().startOf('day'))
    }

    const disabledDate = (current) => {
        if (!current) return false
        const beforeToday = current.isBefore(moment().startOf('day'))
        if (startDate) {
            const beforeStart = current.isBefore(moment(startDate, 'YYYY-MM-DD').startOf('day'))
            return beforeToday || beforeStart
        }
        return beforeToday
    }

    const disabledStartTimeHours = () => {
        const hours = []
        if (moment().format('YYYY-MM-DD') === startDate) {
            for (let i = 0; i < moment().hour(); i++) hours.push(i)
        }
        return hours
    }

    const disabledStartTimeMinutes = (selectedHour) => {
        const minutes = []
        if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === startDate) {
            for (let i = 0; i <= (moment().minute() + 1); i++) minutes.push(i)
        }
        return minutes
    }

    const disabledEndTimeHours = () => {
        const hours = []
        if (startTime) {
            const startHour = moment(startTime, 'HH:mm').hour()
            for (let i = 0; i < startHour; i++) hours.push(i)
        }
        return hours
    }

    const disabledEndTimeMinutes = (selectedHour) => {
        const minutes = []
        if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === startDate) {
            for (let i = 0; i < (moment(startTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
        } else if (startTime && selectedHour === moment(startTime, 'HH:mm').hour()) {
            for (let i = 0; i < (moment(startTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
        }
        return minutes
    }

    const createSchedule = () => {
        const today = moment().startOf('day')
        if (startDate && moment(startDate, 'YYYY-MM-DD').isBefore(today)) { Notification.error('Error', 'Start date cannot be in the past'); return }
        if (endDate && moment(endDate, 'YYYY-MM-DD').isBefore(today)) { Notification.error('Error', 'End date cannot be in the past'); return }
        if (startDate && endDate && moment(endDate, 'YYYY-MM-DD').isBefore(moment(startDate, 'YYYY-MM-DD'))) { Notification.error('Error', 'End date cannot be before start date'); return }

        if (subId && startTime && endTime && startDate && endDate && mode && classId.length != 0 && teacherId && weekdays.length != 0) {
            if ((mode !== 'Offline' && mode !== 'Others') && ((subsAlertData?.totalUserHours == 0) || (subsAlertData?.userHoursUsed >= subsAlertData?.totalUserHours))) {
                setIsSubModalVisible(true)
                return
            }

            var objectSchedule = {
                teacherId: teacherId,
                subjectId: subId,
                classIds: classId,
                weekdays: weekdays,
                startTime: startTime,
                endTime: endTime,
                mode: mode,
                startDate: startDate,
                endDate: endDate
            }
            if (togglePageLoader) togglePageLoader(true)
            return postCreateSchedule(objectSchedule, () => togglePageLoader && togglePageLoader(false), successCallback)
        } else {
            Notification.error('Error', 'please fill all the information')
        }
    }

    const successCallback = () => {
        EventRegister.emit('apicall:scheduleHome')
        if (togglePageLoader) togglePageLoader(false)
        handleReset()
        onClose()
    }

    const handleReset = () => {
        setSubject(null)
        setSubName('')
        setTeacher(null)
        setTeacherName('')
        setSartDate('')
        setEndDate('')
        setStartTime('')
        setEndTime('')
        setMode('')
        setWeekDays([])
        setColorDays([false, false, false, false, false, false, false])
        setClass([])
        setClassNameArr([])
        setShowBatchInput(false)
        setSubjectLoader(false)
        setStdLoader(false)
        setTeacherLoader(false)
        setBatchDropdownOpen(false)
        setClassName('')
        setBatchFocused(false)
    }

    const handleClose = () => {
        handleReset()
        onClose()
    }

    const handleBatchFieldClick = () => {
        if (subId) {
            setShowBatchInput(true)
            setBatchDropdownOpen(true)
            fetchClassList('', subId)
        }
    }

    const selectedBatches = Array.isArray(classId) ? classId : [];
    const availableBatches = (cachedClassList || classList || []).filter(c => !selectedBatches.includes(c.id));
    const showAddBatch = selectedBatches.length > 0 && availableBatches.length > 0;

    return (
        <Drawer
            zIndex={99999}
            placement="right"
            width={drawerWidth}
            className="scaled-drawer"
            open={open}
            destroyOnClose
            onClose={handleClose}
            closeIcon={null}
            title={null}
            headerStyle={{
                padding: 0,
                border: 'none',
                minHeight: 'auto'
            }}
            bodyStyle={{ padding: 0 }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
                {pageLoader && ReactDOM.createPortal(
                    <PageDataLoader visible={true} />,
                    document.body
                )}
                <div
                    style={{
                        padding: '30px 35px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <div
                        style={{
                            fontSize: 18,
                            fontWeight: 500,
                            color: '#000000',
                            paddingBottom: 8
                        }}
                    >
                        Create Schedule
                    </div>
                    <CloseOutlined
                        onClick={handleClose}
                        style={{
                            fontSize: 18,
                            color: '#AEAEAE',
                            cursor: 'pointer',
                            paddingBottom: 8
                        }}
                    />
                </div>

                <div
                    className="schedule-create-drawer-body"
                    id="drawer-scroll-container"
                    style={{
                        // 40px each side => 512px effective content width inside the 592px panel, per spec
                        padding: '10px 40px',
                        fontFamily: 'Roboto, sans-serif',
                        paddingBottom: 24,
                        boxSizing: 'border-box',
                        position: 'relative',
                        flex: 1,
                        // Always clips ('auto', never 'visible') - a date/time popup that needs more
                        // room than is currently visible gets a scrollbar via this same overflow,
                        // instead of an unclipped popup dragging unrelated trailing content (like the
                        // Repeat-on row) into overlapping the footer along with it. scrollFieldIntoView
                        // (see the picker's onOpenChange below) scrolls the opened field to the top of
                        // this container first, to leave as much room below as possible before that
                        // scrollbar is ever needed.
                        overflowY: 'auto',
                        minHeight: 0,
                        width: '100%'
                    }}
                >
                    {/* Subject Field */}
                    <div id="create-subject-field" style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: (subFocused || subName || subId) ? '0px' : '30px',
                                fontSize: '16px',
                                color: '#636363',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                                pointerEvents: 'none',
                            }}
                        >
                            Subject <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>

                        <div style={{ position: 'relative', width: '100%' }}>
                            <Tooltip title={subName} placement="topLeft" mouseEnterDelay={0.5}>
                                <AutoComplete
                                    className="custom-schedule-select"
                                    popupClassName="schedule-create-dropdown-v2"
                                    style={{ width: '100%' }}
                                    virtual={false}
                                    dropdownMatchSelectWidth={true}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    options={optionSub}
                                    open={subjectDropdownOpen}
                                    notFoundContent={subjectLoader ? 'Loading...' : <div style={{ padding: '8px 12px', color: '#6B6B6B' }}>No subject found</div>}
                                    onSearch={handleSearchSub}
                                    onSelect={(value, option) => {
                                        onSelectSub(value, option);
                                        setSubjectDropdownOpen(false);
                                    }}
                                    onFocus={() => {
                                        setSubFocused(true);
                                        setIsSearchingSub(false);
                                        fetchSubList('');
                                        setSubjectDropdownOpen(true);
                                        setShowBatchInput(false);
                                        setBatchFocused(false);
                                    }}
                                    onBlur={() => {
                                        setSubFocused(false);
                                    }}
                                    onDropdownVisibleChange={(open) => {
                                        // when suppressed after clear, ignore close events so dropdown stays open
                                        if (suppressSubOptionsUpdate && !open) return;
                                        if (suppressSubOptionsUpdate && open) {
                                            setSubjectDropdownOpen(true);
                                            return;
                                        }
                                        setSubjectDropdownOpen(open);

                                        if (open) {
                                            const list = cachedSubList || subList || [];
                                            setOptionsSub(list ? list.map((item, index) => ({
                                                key: index,
                                                value: item.name,
                                                label: item.name,
                                                id: item.id
                                            })) : []);
                                            fetchSubList('');
                                        }
                                    }}

                                    onChange={(value) => {
                                        if (!value) {
                                            setSubName('');
                                            setSubject(null);
                                            setClass([]);
                                            setClassNameArr([]);
                                            setClassName('');
                                            setShowBatchInput(false);
                                            setCachedClassList(null); // Clear cache to hide button

                                            if (isManualClearRef.current) {
                                                isManualClearRef.current = false;
                                                setSubFocused(true);
                                                setSubjectDropdownOpen(true);
                                                // Don't blur
                                            } else {
                                                setSubFocused(false);
                                                subRef.current?.blur();
                                                setSubjectDropdownOpen(false);
                                            }

                                            // Prevent useEffect from immediately overwriting our options while we refresh
                                            setSuppressSubOptionsUpdate(true);

                                            // Refresh subjects in background
                                            const list = (cachedSubList && cachedSubList.length > 0) ? cachedSubList : (subList || []);
                                            if (list && list.length > 0) {
                                                setOptionsSub(list.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })));
                                                // allow the background fetch to update options after suppression window
                                                setTimeout(() => setSuppressSubOptionsUpdate(false), 1000);
                                                // Refresh subjects in background to update options without causing flicker
                                                setTimeout(() => fetchSubList(''), 300);
                                            } else {
                                                // allow the background fetch to update options after suppression window
                                                setTimeout(() => setSuppressSubOptionsUpdate(false), 1000);
                                                // Fetch fresh list
                                                fetchSubList('', () => setSubjectLoader(false));
                                            }
                                        } else {
                                            isManualClearRef.current = false;
                                        }
                                    }}
                                    ref={subRef}
                                    filterOption={false}
                                    value={subName}
                                    allowClear
                                    placeholder=""
                                    dropdownStyle={{ marginTop: 2 }}
                                >
                                    <Input
                                        bordered={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Backspace' || e.key === 'Delete') {
                                                isManualClearRef.current = true;
                                            }
                                            const noSubFound = !optionSub || optionSub.length === 0 || (optionSub.length === 1 && optionSub[0].key === 'no-data');
                                            if (e.key === 'Enter') {
                                                if (!subName || noSubFound) {
                                                    e.preventDefault();
                                                    setIsSearchingSub(false);
                                                    setSubjectDropdownOpen(true);
                                                    fetchSubList('');
                                                } else if (optionSub && optionSub.length > 0) {
                                                    // Select the first valid option if available
                                                    const firstValid = optionSub.find(o => o.key !== 'no-data');
                                                    if (firstValid) {
                                                        onSelectSub(firstValid.value, firstValid);
                                                        setSubjectDropdownOpen(false);
                                                    }
                                                }
                                            }
                                        }}
                                        style={{
                                            padding: 0,
                                            fontSize: 18,
                                            color: '#191919',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap'
                                        }}
                                    />
                                </AutoComplete>
                            </Tooltip>
                        </div>

                        <div
                            style={{
                                width: '100%',
                                height: '0px',
                                borderTop: '1px solid #E6E6E6',
                                opacity: 1,
                            }}
                        />
                    </div>

                    {/* Batch Field */}
                    <div style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (subId && (batchFocused || classNameArr.length > 0 || showBatchInput)) ? '0px' : '30px',
                            fontSize: '16px',
                            color: '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            Batch <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>

                        {/* Selected Batches List */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {(classNameArr || []).map((c) => (
                                <div key={c.id}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '4px 0 0px 0'
                                        }}
                                    >
                                        <span style={{
                                            fontSize: 18,
                                            color: '#191919',
                                            fontWeight: 500
                                        }}>
                                            {c.name}
                                        </span>
                                        <img
                                            src={deleteIcon}
                                            onClick={() => onClose_Class(c.id)}
                                            alt="delete"
                                            style={{
                                                width: 24,
                                                height: 24,
                                                opacity: 1,
                                                cursor: 'pointer',
                                                filter: 'invert(40%) sepia(90%) saturate(1500%) hue-rotate(330deg) brightness(95%) contrast(105%)',
                                                marginRight: -4
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                                </div>
                            ))}
                        </div>

                        {/* Input Area */}
                        <div id="create-batch-input-area" style={{ position: 'relative', marginTop: classNameArr.length > 0 ? 18 : 0 }}>
                            {classNameArr.length === 0 && !showBatchInput ? (
                                <div
                                    onClick={handleBatchFieldClick}
                                    style={{
                                        cursor: subId ? 'pointer' : 'not-allowed',
                                    }}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '4px 0 0px 0'
                                    }}>
                                        <div style={{
                                            fontSize: 18,
                                            color: '#A0A0A0',
                                            fontWeight: 500,
                                            height: 22
                                        }}>
                                            {/* Initially empty as per request */}
                                        </div>
                                        <img
                                            src={downArrowIcon}
                                            alt="down arrow"
                                            style={{
                                                width: 24,
                                                height: 24,
                                                marginRight: -4,
                                                cursor: subId ? 'pointer' : 'not-allowed'
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: '100%', height: 0, borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                                </div>
                            ) : showBatchInput ? (
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <AutoComplete
                                        className="custom-schedule-select"
                                        popupClassName="schedule-create-dropdown-v2"
                                        style={{ width: '100%' }}
                                        virtual={false}
                                        dropdownMatchSelectWidth={true}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        options={optionClass}
                                        onSearch={handleSearchClass}
                                        onSelect={(value, option) => {
                                            onSelectClass(value, option);
                                            setClassName('');
                                        }}
                                        onChange={(value) => { if (!value) setClassName('') }}
                                        value={className}
                                        placeholder={classNameArr.length > 0 ? "select batch" : ""}
                                        disabled={!subId}
                                        onFocus={() => {
                                            setBatchFocused(true);
                                            setBatchDropdownOpen(true);
                                            if (subId) fetchClassList('', subId)
                                        }}
                                        onDropdownVisibleChange={(open) => {
                                            setBatchDropdownOpen(open);
                                            // Dropdown can close from an outside click without the input ever
                                            // being focused/blurred (e.g. opened via the field click, then
                                            // dismissed by clicking elsewhere). Collapse back then too, so the
                                            // label doesn't stay stuck floating on an empty field.
                                            if (!open && classNameArr.length === 0 && !className) {
                                                setShowBatchInput(false);
                                                setBatchFocused(false);
                                            }
                                        }}
                                        onBlur={() => {
                                            setBatchFocused(false);
                                            setTimeout(() => setBatchDropdownOpen(false), 200)
                                            // If nothing was selected and no batches exist yet, collapse the
                                            // input back so the label drops back to its placeholder position
                                            if (classNameArr.length === 0 && !className) {
                                                setShowBatchInput(false);
                                            }
                                        }}
                                        open={batchDropdownOpen}
                                        filterOption={false}
                                        dropdownStyle={{ marginTop: 2 }}
                                    >
                                        <Input
                                            bordered={false}
                                            style={{
                                                padding: 0,
                                                fontSize: 18,
                                                color: '#191919',
                                                fontWeight: 500,
                                                cursor: subId ? 'pointer' : 'not-allowed',
                                                height: 22
                                            }}
                                            suffix={
                                                <img
                                                    src={batchDropdownOpen ? upArrowIcon : downArrowIcon}
                                                    alt={batchDropdownOpen ? "up arrow" : "down arrow"}
                                                    style={{
                                                        width: 24,
                                                        height: 24,
                                                        cursor: 'pointer',
                                                        marginRight: -4
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (batchDropdownOpen) {
                                                            setBatchDropdownOpen(false)
                                                        } else {
                                                            setBatchDropdownOpen(true)
                                                            fetchClassList('', subId)
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </AutoComplete>
                                    <div style={{ width: '100%', height: 0, borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                                </div>
                            ) : null}
                        </div>

                        {subId && showBatchInput && classNameArr.length > 0 ? (
                            // "DISCARD" link — mirrors ScheduleEditTab.js: only shown while
                            // adding an extra batch to an already non-empty selection, cancels
                            // the in-progress add via the same state setters already used for
                            // the existing blur/collapse behavior. Presentational only.
                            <div style={{ textAlign: 'right', marginTop: 16 }}>
                                <div
                                    onClick={() => {
                                        setShowBatchInput(false);
                                        setBatchDropdownOpen(false);
                                        setBatchFocused(false);
                                        setClassName('');
                                    }}
                                    style={{
                                        color: '#636363',
                                        fontWeight: 700,
                                        fontSize: 18,
                                        cursor: 'pointer',
                                        userSelect: 'none'
                                    }}
                                    role="button"
                                >
                                    DISCARD
                                </div>
                            </div>
                        ) : subId && !showBatchInput ? (
                            <>
                                <div style={{ textAlign: 'right', marginTop: 16 }}>
                                    {showAddBatch && (
                                        <div
                                            onClick={() => {
                                                if (subId) {
                                                    setShowBatchInput(true);
                                                    setBatchDropdownOpen(false);
                                                    fetchClassList('', subId);
                                                }
                                            }}
                                            style={{
                                                color: subId ? '#1089FF' : '#A0A0A0',
                                                fontWeight: 700,
                                                fontSize: 18,
                                                cursor: subId ? 'pointer' : 'not-allowed',
                                                userSelect: 'none'
                                            }}
                                            role="button"
                                            aria-disabled={!subId}
                                        >
                                            ADD BATCH
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : null}
                    </div>

                    {/* Instructor Field */}
                    <div id="create-instructor-field" style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (teacherFocused || teacherName || teacherId) ? '0px' : '30px',
                            fontSize: '16px',
                            color: '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            Instructor <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <AutoComplete
                                className="custom-schedule-select"
                                popupClassName="schedule-create-dropdown-v2"
                                style={{ width: '100%' }}
                                virtual={false}
                                dropdownMatchSelectWidth={true}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                options={optionTeacher}
                                onSearch={handleSearchTeacher}
                                onSelect={(value, option) => {
                                    onSelectTeacher(value, option);
                                    setTeacherDropdownOpen(false);
                                }}
                                onFocus={() => {
                                    setTeacherFocused(true);
                                    setIsSearchingTeacher(false);
                                    fetchTeacherList('');
                                    setTeacherDropdownOpen(true);
                                }}
                                onBlur={() => {
                                    setTeacherFocused(false);
                                }}
                                onDropdownVisibleChange={(open) => {
                                    setTeacherDropdownOpen(open);
                                }}
                                onChange={(value) => {
                                    if (!value) {
                                        setTeacherName('')
                                        setTeacher(null)
                                        if (isManualClearRef.current) {
                                            isManualClearRef.current = false;
                                            setTeacherFocused(true);
                                        } else {
                                            setTeacherFocused(false)
                                            instructorRef.current?.blur()
                                        }
                                    } else {
                                        isManualClearRef.current = false;
                                    }
                                }}
                                ref={instructorRef}
                                value={teacherName}
                                open={teacherDropdownOpen}
                                notFoundContent={teacherLoader ? 'Loading...' : <div style={{ padding: '8px 12px', color: '#6B6B6B' }}>No instructor found</div>}
                                allowClear={true}
                                placeholder=""
                                filterOption={false}
                                dropdownStyle={{ marginTop: 2 }}
                            >
                                <Input
                                    bordered={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Backspace' || e.key === 'Delete') {
                                            isManualClearRef.current = true;
                                        }
                                        const noTeacherFound = !optionTeacher || optionTeacher.length === 0 || (optionTeacher.length === 1 && optionTeacher[0].key === 'no-data');
                                        if (e.key === 'Enter') {
                                            if (!teacherName || noTeacherFound) {
                                                e.preventDefault();
                                                setIsSearchingTeacher(false);
                                                setTeacherDropdownOpen(true);
                                            } else if (optionTeacher && optionTeacher.length > 0) {
                                                // Select the first valid option if available
                                                const firstValid = optionTeacher.find(o => o.key !== 'no-data');
                                                if (firstValid) {
                                                    onSelectTeacher(firstValid.value, firstValid);
                                                    setTeacherDropdownOpen(false);
                                                }
                                            }
                                        }
                                    }}
                                    style={{
                                        padding: 0,
                                        fontSize: 18,
                                        color: '#191919',
                                        fontWeight: 500,
                                        cursor: 'pointer'
                                    }}
                                />
                            </AutoComplete>
                        </div>
                        <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                    </div>

                    <style>
                        {`
                    .schedule-create-dropdown .ant-select-item-option-selected {
                        background-color: #C6C2FF !important;
                        color: #191919 !important;
                        font-weight: 500;
                    }

                    .schedule-create-dropdown .ant-select-item-option-active {
                        background-color: rgba(198, 194, 255, 0.6) !important;
                    }

                    .schedule-create-dropdown .ant-select-item {
                        border-radius: 8px;
                        margin: 4px;
                    }
                `}
                    </style>

                    {/* Mode of Class */}
                    <div style={{ marginBottom: fieldGap }}>
                        <div
                            style={{
                                fontSize: 16,
                                color: '#636363',
                                marginBottom: 8,
                                fontWeight: 500,
                            }}
                        >
                            Mode of class <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>

                        <div style={{ display: 'flex', gap: 10 }}>
                            {['Broadcast', 'Offline', 'Others'].map((m) => (
                                <div
                                    key={m}
                                    onClick={() => setMode(m)}
                                    style={{
                                        padding: '8px 32px',
                                        borderRadius: 12,
                                        border: mode === m ? 'none' : '1px solid #E6E6E6',
                                        background: mode === m ? '#C6C2FF' : '#FFFFFF',
                                        color: '#191919',
                                        fontSize: 18,
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {m === 'Broadcast' ? 'Online' : m}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Date Fields */}
                    <div style={{ display: 'flex', gap: 24, marginBottom: fieldGap }}>
                        <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                            <div style={{
                                position: 'absolute',
                                left: 0,
                                top: (startDateFocused || startDate) ? '0px' : '30px',
                                fontSize: '16px',
                                color: '#636363',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                                pointerEvents: 'none',
                            }}>
                                Start date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                            </div>
                            <div ref={startDateWrapRef} onMouseEnter={() => setHoverStartDate(true)} onMouseLeave={() => setHoverStartDate(false)} className="datepicker-timepicker-relative-container">
                                <DatePicker
                                    value={startDate ? moment(startDate, 'YYYY-MM-DD') : null}
                                    format={formatDate}
                                    onChange={onChangeStartDate}
                                    onOpenChange={(open) => { setStartDateFocused(open); if (open) scrollFieldIntoView(startDateWrapRef); }}
                                    style={pickerStyle}
                                    inputReadOnly
                                    bordered={false}
                                    disabledDate={disabledStartDate}
                                    suffixIcon={(startDate && hoverStartDate) ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
                                    allowClear={true}
                                    placeholder=""
                                    popupStyle={{ marginTop: 30 }}
                                    ref={startDateRef}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                />
                            </div>
                            <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                        </div>
                        <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                            <div style={{
                                position: 'absolute',
                                left: 0,
                                top: (endDateFocused || endDate) ? '0px' : '30px',
                                fontSize: '16px',
                                color: '#636363',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                                pointerEvents: 'none',
                            }}>
                                End date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                            </div>
                            <div ref={endDateWrapRef} onMouseEnter={() => setHoverEndDate(true)} onMouseLeave={() => setHoverEndDate(false)} className="datepicker-timepicker-relative-container">
                                <DatePicker
                                    value={endDate ? moment(endDate, 'YYYY-MM-DD') : null}
                                    format={formatDate}
                                    onChange={onChangeLastDate}
                                    onOpenChange={(open) => { setEndDateFocused(open); if (open) scrollFieldIntoView(endDateWrapRef); }}
                                    style={pickerStyle}
                                    inputReadOnly
                                    bordered={false}
                                    disabled={!startDate}
                                    disabledDate={disabledDate}
                                    suffixIcon={(endDate && hoverEndDate) ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
                                    allowClear={true}
                                    placeholder=""
                                    popupStyle={{ marginTop: 30 }}
                                    ref={endDateRef}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                />
                            </div>
                            <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                        </div>
                    </div>

                    {/* Time Fields */}
                    <div style={{ display: 'flex', gap: 24, marginBottom: fieldGap }}>
                        <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                            <div style={{
                                position: 'absolute',
                                left: 0,
                                top: (startTimeFocused || startTime) ? '0px' : '30px',
                                fontSize: '16px',
                                color: '#636363',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                                pointerEvents: 'none',
                            }}>
                                Start time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                            </div>
                            <div ref={startTimeWrapRef} onMouseEnter={() => setHoverStartTime(true)} onMouseLeave={() => setHoverStartTime(false)} className="datepicker-timepicker-relative-container">
                                <TimePicker
                                    value={startTime ? moment(startTime, 'HH:mm') : null}
                                    format={format}
                                    onChange={onChangeStartTime}
                                    onOpenChange={(open) => { setStartTimeFocused(open); if (open) scrollFieldIntoView(startTimeWrapRef); }}
                                    style={pickerStyle}
                                    inputReadOnly
                                    bordered={false}
                                    disabled={!(startDate && endDate)}
                                    disabledHours={() => disabledStartTimeHours()}
                                    disabledMinutes={disabledStartTimeMinutes}
                                    suffixIcon={(startTime && hoverStartTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
                                    allowClear={true}
                                    placeholder=""
                                    showNow={false}
                                    popupStyle={{ marginTop: 30 }}
                                    ref={startTimeRef}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                />
                            </div>
                            <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                        </div>
                        <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                            <div style={{
                                position: 'absolute',
                                left: 0,
                                top: (endTimeFocused || endTime) ? '0px' : '30px',
                                fontSize: '16px',
                                color: '#636363',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                                pointerEvents: 'none',
                            }}>
                                End time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                            </div>
                            <div ref={endTimeWrapRef} onMouseEnter={() => setHoverEndTime(true)} onMouseLeave={() => setHoverEndTime(false)} className="datepicker-timepicker-relative-container">
                                <TimePicker
                                    value={endTime ? moment(endTime, 'HH:mm') : null}
                                    format={format}
                                    onChange={onChangeEndTime}
                                    onOpenChange={(open) => { setEndTimeFocused(open); if (open) scrollFieldIntoView(endTimeWrapRef); }}
                                    style={pickerStyle}
                                    inputReadOnly
                                    bordered={false}
                                    disabled={!startTime}
                                    disabledHours={() => disabledEndTimeHours()}
                                    disabledMinutes={disabledEndTimeMinutes}
                                    suffixIcon={(endTime && hoverEndTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
                                    allowClear={true}
                                    placeholder=""
                                    showNow={false}
                                    popupStyle={{ marginTop: 30 }}
                                    ref={endTimeRef}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                />
                            </div>
                            <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                        </div>
                    </div>

                    {/* Repeat On */}
                    <div style={{ marginBottom: fieldGap }}>
                        <div style={{
                            fontSize: 16,
                            color: '#636363',
                            marginBottom: 10,
                            fontWeight: 500
                        }}>
                            Repeat on <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div style={{ display: 'flex', gap: 12, justifyContent: 'space-between' }}>
                            {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d, i) => {
                                const dayMap = ['Su', 'M', 'T', 'W', 'Th', 'F', 'S']
                                return (
                                    <div
                                        key={d}
                                        onClick={() => handleDaysButtonColor(dayMap[i], colorDays[i])}
                                        style={{
                                            width: 51,
                                            height: 51,
                                            borderRadius: '50%',
                                            background: colorDays[i] ? '#C6C2FF' : '#FFFFFF',
                                            border: colorDays[i] ? 'none' : '1px solid #E6E6E6',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 18,
                                            fontWeight: 500,
                                            color: '#191919',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        {d}
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    {/* Action Buttons (fixed footer) */}
                    <div style={{ height: 12 }} />
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 10,
                    padding: '16px 24px',
                    background: '#FFFFFF',
                    boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
                    borderTop: '1px solid #E6E6E6',
                    width: '100%',
                    boxSizing: 'border-box'
                }}>
                    <button
                        onClick={handleReset}
                        disabled={!(subId || startTime || endTime || startDate || endDate || mode || (classId && classId.length) || teacherId || (weekdays && weekdays.length))}
                        style={{
                            width: 140,
                            height: 45,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            borderColor: '#636363',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#FFFFFF',
                            color: '#636363',
                            fontSize: 18,
                            fontWeight: 700,
                            cursor: (subId || startTime || endTime || startDate || endDate || mode || (classId && classId.length) || teacherId || (weekdays && weekdays.length)) ? 'pointer' : 'not-allowed',
                            letterSpacing: '0.5px',
                            transition: 'all 0.2s ease',
                            opacity: (subId || startTime || endTime || startDate || endDate || mode || (classId && classId.length) || teacherId || (weekdays && weekdays.length)) ? 1 : 0.7,
                            padding: 0
                        }}
                    >
                        RESET
                    </button>
                    <button
                        onClick={() => {
                            if (isFormValid) {
                                setModalConfig({
                                    type: 'createSchedule',
                                    title: 'Confirm',
                                    message: "Are you sure you want to create this schedule?",
                                    confirmText: 'YES'
                                });
                                setShowModal(true);
                            }
                        }}
                        disabled={pageLoader || !isFormValid}
                        style={{
                            width: 140,
                            height: 45,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            borderColor: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#594099',
                            color: '#FFFFFF',
                            fontSize: 18,
                            fontWeight: 700,
                            cursor: pageLoader || !isFormValid ? 'not-allowed' : 'pointer',
                            letterSpacing: '0.5px',
                            opacity: pageLoader || !isFormValid ? 0.7 : 1,
                            transition: 'all 0.2s ease',
                            padding: 0
                        }}
                    >
                        SAVE
                    </button>
                </div>
                {/* SavingModal (components/SavingModal.js) is shared across 8 schedule-module
                files (ResourcesPanel, ResourceAddForm, QuizzesPanel, scheduleAddQuiz,
                ScheduleDetailsDrawer, ScheduleDetailsTab, etc.) for unrelated confirmation
                dialogs — restyling it here would change all of them, so it is left as-is
                and is out of scope for this pass. */}
                <SavingModal
                    visible={showModal}
                    title={modalConfig.title}
                    message={modalConfig.message}
                    confirmText={modalConfig.confirmText}
                    cancelText={'NO'}
                    onCancel={() => setShowModal(false)}
                    onConfirm={async () => {
                        setShowModal(false)
                        await createSchedule()
                    }}
                />
            </div>
        </Drawer >
    )
}

const mapStateToProps = (state) => {
    const {
        subList,
        subId,
        classList,
        teacherList,
        weekdays,
        classId,
        teacherId,
        startTime,
        endTime,
        startDate,
        endDate,
        mode,
        tabType,
        stdTimetable,
        currentDate,
        teacherSearch,
        classFilter,
        subFilter,
        subsAlertData
    } = state.schedule

    return {
        subList,
        subId,
        classList,
        teacherList,
        weekdays,
        classId,
        teacherId,
        startTime,
        endTime,
        startDate,
        endDate,
        mode,
        tabType,
        stdTimetable,
        currentDate,
        teacherSearch,
        classFilter,
        subFilter,
        subsAlertData
    }
}

const mapDispatchToProps = (dispatch) => ({
    setSubject: (subId) => dispatch(setSubject(subId)),
    setClass: (classId) => dispatch(setClass(classId)),
    setTeacher: (teacherId) => dispatch(setTeacher(teacherId)),
    setStartTime: (time) => dispatch(setStartTime(time)),
    setEndTime: (time) => dispatch(setEndTime(time)),
    setSartDate: (date) => dispatch(setSartDate(date)),
    setEndDate: (date) => dispatch(setEndDate(date)),
    setMode: (mode) => dispatch(setMode(mode)),
    setWeekDays: (week) => dispatch(setWeekDays(week)),
    fetchSubList: (search, callback) => dispatch(fetchSubList(search, callback)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    fetchTeacherList: (search, callback) => dispatch(fetchTeacherList(search, callback)),
    postCreateSchedule: (object, callback, successCallback) => dispatch(postCreateSchedule(object, callback, successCallback)),
    fetchSchedule: (callback, date) => dispatch(fetchSchedule(callback, date)),
    fetchTimetableData: (id, callback) => dispatch(fetchTimetableData(id, callback)),
    fetchScheduleFilter: (date, topic, std, sub) => dispatch(fetchScheduleFilter(date, topic, std, sub)),
    setCurrentDate: (date) => dispatch(setCurrentDate(date)),
})


const styles = `
  /* schedule-create-dropdown is the element rc-trigger sets its own inline
     "position/top" on for placement, so margin/top overrides here fight that
     JS-computed value instead of reliably landing. Leave its own box alone
     (transparent, no shadow/padding) and push the gap/radius/shadow onto its
     rendered child instead — a plain CSS-only fix, no dropdownRender prop
     needed, so there's nothing here for a JSX-prop revert to strip out. */
  body .schedule-create-dropdown-v2,
  .schedule-create-dropdown-v2 {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
    transform: none !important;
    min-width: unset !important;
    max-width: 100% !important;
    overflow: hidden !important;
    /* Same fix as ScheduleEditTab.js's identical dropdown: this wrapper's own
       overflow:hidden was clipping the rendered child's box-shadow at its own
       square corners - round them to match the child's 12px radius. */
    border-radius: 12px !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin-top: 22px !important;
    z-index: 1200 !important;
  }

  body .schedule-create-dropdown-v2 > *,
  .schedule-create-dropdown-v2 > * {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-top: 8px !important;
    border-radius: 12px !important;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16) !important;
    /* Same fix as ScheduleEditTab.js's identical dropdown: the centered
       zero-offset/spread shadow alone was too soft to read as an edge on a
       white background - add a hairline border matching the other fields. */
    border: 1px solid #E6E6E6 !important;
    background: #ffffff !important;
    padding: 8px 4px !important;
  }

  /* Prevent empty or hidden dropdowns from rendering a phantom shadow box */
  body .schedule-create-dropdown-v2.ant-select-dropdown-empty,
  .schedule-create-dropdown-v2.ant-select-dropdown-empty,
  body .schedule-create-dropdown-v2.ant-select-dropdown-hidden,
  .schedule-create-dropdown-v2.ant-select-dropdown-hidden {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  body .schedule-create-dropdown-v2.ant-select-dropdown-empty > *,
  .schedule-create-dropdown-v2.ant-select-dropdown-empty > *,
  body .schedule-create-dropdown-v2.ant-select-dropdown-hidden > *,
  .schedule-create-dropdown-v2.ant-select-dropdown-hidden > * {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
  }

  body .schedule-create-dropdown-v2 .rc-virtual-list,
  body .schedule-create-dropdown-v2 .rc-virtual-list-holder,
  body .schedule-create-dropdown-v2 .rc-virtual-list-holder-inner {
    width: 100% !important;
    max-width: 100% !important;
  }

  .datepicker-timepicker-relative-container {
    position: relative;
    width: 100%;
  }

  /* getPopupContainer keeps the dropdown rendered inside the Drawer's own DOM
     subtree instead of antd's default document.body portal - needed so it
     inherits this Drawer's stacking context correctly instead of risking
     rendering behind it. Always opens downward (default antd placement) - the
     scroll container's overflow now stays 'auto' at all times instead of
     lifting to 'visible' while a field is focused, so a popup that needs more
     room than is visible gets a scrollbar (see scrollFieldIntoView, which
     scrolls the field to the top of the container when its picker opens, to
     leave as much room below as possible) rather than overlapping whatever
     comes after it in the form. */
  body .datepicker-timepicker-relative-container .ant-picker-dropdown,
  .datepicker-timepicker-relative-container .ant-picker-dropdown {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    transform: none !important;
    margin-top: 30px !important;
    z-index: 1200 !important;
  }



  body .schedule-create-dropdown-v2 .ant-select-item-option-content,
  body .schedule-create-dropdown-v2 .ant-select-item {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  body .schedule-create-dropdown-v2 .ant-select-item-option-selected,
  body .schedule-create-dropdown-v2 .custom-selected-option {
    background-color: #C6C2FF !important;
    color: #191919 !important;
    font-weight: 400;
    font-size: 14px !important;
  }

  body .schedule-create-dropdown-v2 .ant-select-item-option-active {
    background-color: #C6C2FF !important;
  }

  body .schedule-create-dropdown-v2 .ant-select-item {
    border-radius: 8px;
    margin: 4px;
    padding: 6px 16px;
    font-size: 14px !important;
    color: #636363;
  }

  body .schedule-create-dropdown-v2 .ant-select-item-option-content {
    font-size: 14px !important;
  }
`;

if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.appendChild(document.createTextNode(styles));
    document.head.appendChild(styleElement);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateScheduleDrawer)